export const DETECTION_OPTIONS = {
  order: ["localStorage", "navigator"],
  caches: ["localStorage"]
};
